
<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Home',

    metaInfo: { title: 'Home' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-carousel',
        // 'hero',
        'product-center',
        // 'direction',
        'about-us-new',
        // 'about-our-product',
        // 'theme-features',
        // 'recent-podcasts',
        // 'customer-reviews',
        // 'team',
        // 'affiliates',
        // 'background-info',
        // 'contact-us',
        // 'news',
        'keep-in-touch2', // 联系我们
        // 'social-media',
        // 'newsletter',
        // 'info-alt',
        // 'gallery',
        // 'project',
        // 'recent-works',
        // 'newsletter',
        // 'info',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'home',
      },
    },
  }
</script>
